import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { VideoPureComponent } from '@bingads-webui-campaign-react/video-pure-component';

import { getControlStyles } from './styles';

export const Video = withDefaultStyles(VideoPureComponent, getControlStyles);
